export default "__VITE_ASSET__81414068__"